import { uploadArchive } from '@/core/domain/archive/Archive/Archive.service';

type Callback = (data: File[]) => Promise<string[]>;
type Uploading = (loading: boolean) => void;

export default async function mailBase64ToUrl(
  html: string,
  uploading?: Uploading,
  callback?: Callback,
) {
  !!uploading && uploading(true);

  const template = document.createElement('template');
  template.innerHTML = html;

  const nodes = Array.from(
    template.content.querySelectorAll('img[src^="data:image/"]'),
  );

  const base64List: string[] = [];

  for (const img of nodes) {
    const imgSrc = img.getAttribute('src');
    if (imgSrc) {
      base64List.push(imgSrc);
    }
  }

  const files = await Promise.all(
    base64List.map(async (dataUrl) => {
      const dataType = dataUrl.match(/^data:(.+);base64/)?.[1];
      const extension = dataType?.split('/').at(-1)?.toLowerCase();
      const res = await fetch(dataUrl);
      const blob = await res.blob();

      return new File([blob], `${new Date().toISOString()}.${extension}`, {
        type: dataType,
      });
    }),
  );

  let urlList: string[] = [];

  if (files.length) {
    if (callback) {
      urlList = await callback(files);
    } else {
      urlList = await Promise.all(
        files.map(
          async (file) =>
            (
              await uploadArchive({ file: [file], isPublic: true })
            ).filePath,
        ),
      );
    }
  }

  let i = 0;

  for (const img of nodes) {
    img.setAttribute('src', urlList[i]);
    i = i + 1;
  }

  const newHtml = template.innerHTML;

  template.remove();

  !!uploading && uploading(false);

  return newHtml;
}
